import { Span } from '@chakra-ui/react';
import { MessageStatus, type Msg } from '@halo/chat-sdk-react';

export interface MsgEncryptFailedContentProps {
  message: Msg;
}

export const MsgEncryptFailedContent = memo(function MsgEncryptFailedContent({
  message,
}: MsgEncryptFailedContentProps) {
  const { t } = useTranslation();
  switch (message?.status) {
    case MessageStatus.FailedEncrypt:
      return <Span color="fg.error">{t('chat.failedToEncryptMessage')}</Span>;
    case MessageStatus.FailedDecrypt:
      return <Span color="fg.error">{t('chat.failedToDecryptMessage')}</Span>;
    default:
      return <Span color="fg.error">{t('chat.failedMessage')}</Span>;
  }
});
